import React from "react";
import { isIconClassType } from "../../icons/IconClasses";
import Icon from "../../icons/Icon";

// icon: none, left, right
// size: xsmall, small, medium, large, xlarge
// type: primary, primary2, secondary, tertiary, white, danger, dark, ghost, transparent
// https://www.figma.com/design/xnr558XUCXb4vkBy6eAif7/%5B%EB%9D%BC%EC%9D%B4%EB%B8%8C%EB%9F%AC%EB%A6%AC%5D-Potoo-Library?node-id=282-4974&t=3lunUvpzgaQBTI5S-4
export type ButtonIconProps = {
  type: string;
  size: string;
  onClick?: () => void;
  iconName: string;
  style?: React.CSSProperties;
  id?: string;
  disabled?: boolean;
  otherClassName?: string;
  iconOtherClassName?: string;
};

const ButtonIcon = (props: ButtonIconProps) => {
  const {
    type,
    size,
    onClick,
    iconName,
    style,
    id,
    disabled = false,
    otherClassName = "",
    iconOtherClassName = "",
  } = props;

  const getClassName = (type: string) => {
    let className = "";
    switch (type) {
      case "primary":
        className = "btn-primary ";
        break;
      case "primary2":
        className = "btn-primary btn-primary2 ";
        break;
      case "secondary":
        className = "btn-secondary ";
        break;
      case "tertiary":
        className = "btn-tertiary ";
        break;
      case "white":
        className = "btn-white ";
        break;
      case "danger":
        className = "btn-danger ";
        break;
      case "dark":
        className = "btn-dark ";
        break;
      case "ghost":
        className = "btn-ghost ";
        break;
      case "transparent":
        className = "btn-transparent ";
        break;
    }
    return className;
  };

  const getIconClassName = (size: string) => {
    let iconClassName = "";
    let iconSize = 34;
    switch (size) {
      case "xsmall":
        iconClassName = iconClassName + "btn-icon-xsmall ";
        iconSize = 18;
        break;
      case "small":
        iconClassName = iconClassName + "btn-icon-small ";
        iconSize = 24;
        break;
      case "medium":
        iconClassName = iconClassName + "btn-icon-medium  ";
        iconSize = 28;
        break;
      case "large":
        iconClassName = iconClassName + "btn-icon-large  ";
        iconSize = 34;
        break;
      case "xlarge":
        iconClassName = iconClassName + "btn-icon-xlarge  ";
        iconSize = 36;
        break;
    }
    return { iconClassName, iconSize };
  };

  const className = getClassName(type);
  const { iconClassName, iconSize } = getIconClassName(size);

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`${className} ${otherClassName}`}
      style={style}
      id={id}
    >
      {!isIconClassType(iconName) && (
        <i className={`${iconName} ${iconClassName} ${iconOtherClassName}`} />
      )}
      {isIconClassType(iconName) && (
        <Icon name={iconName} className={iconClassName} size={iconSize} />
      )}
    </button>
  );
};

export { ButtonIcon };
